module.exports = __webpack_public_path__ + "media/images/c-projectFeatureLabel/category-1b97f84c115f0c36a706895e00c6dd93.svg";